import React, { useState, useRef} from "react";
import "./VerticalTab.scss";
import AuiIcon from "../AuiDropdown/AuiIcon";

interface FaqItem {
  id: number;
  question: string;
  answer: React.ReactNode;
}

interface Tab {
  id: number;
  label: string;
  faqs : FaqItem[]
}

interface VerticalTabsProps {
  tabsData: Tab[];
}

const VerticalTabs: React.FC<VerticalTabsProps> = ({ tabsData }) => {
  const [activeTab, setActiveTab] = useState<number>(tabsData[0].id);
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleTabClick = (tabId: number) => {
    setActiveTab(tabId);
  };

    const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const nextIndex = (index + 1) % tabsData.length;
      tabRefs.current[nextIndex]?.focus();
      setActiveTab(tabsData[nextIndex].id);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = (index - 1 + tabsData.length) % tabsData.length;
      tabRefs.current[prevIndex]?.focus();
      setActiveTab(tabsData[prevIndex].id);
    } else if (e.key === "Enter" || e.key === " ") {
      handleTabClick(tabsData[index].id);
    }
  };

  return (
    <main className="vertical-tabs-container">
      <div className="tabs" role="tablist">
        {tabsData.map((tab, index) => (
          <React.Fragment key={tab.id}>
            <div
              id={`tab-${tab.id}`}
              className={`tab-item ${activeTab === tab.id ? "active" : ""}`}
              role="tab"
              tabIndex={activeTab === tab.id ? 0 : -1}
              aria-controls={`tab-content-${tab.id}`}
              aria-selected={activeTab === tab.id ? "true" : "false"}
              ref={(el) => (tabRefs.current[index] = el)}
              onClick={() => handleTabClick(tab.id)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            >
              <span>
                {tab.label}
                <span className="icon-arrow-sec d-block d-lg-none">
                  <AuiIcon
                    iconClass={`${
                      tab.id === activeTab ? "arrowup" : "arrowdown"
                    }`}
                    svgwidth="15"
                    svgheight="15"
                  ></AuiIcon>
                </span>
              </span>
            </div>
              <div
                className={`tab-content ${
                  activeTab === tab.id ? "active d-block d-lg-none" : " d-none"
                }`}
                role="tabpanel"
                aria-labelledby={`tab-${tab.id}`}
              >
                {tabsData
                  .filter((tab) => tab.id === activeTab)
                  .map((tab) => (
                    <React.Fragment key={`mobile-panel-${tab.id}`}>
                      <h2 className="h7 font-600">{tab.label}</h2>
                      <div
                        id={`tab-${tab.id}`}
                        key={tab.id}
                        role="tabpanel"
                        aria-labelledby={`tab-${tab.id}`}
                        className="mb-4"
                      >
                      {tab.faqs.map((faq) => (
                        <div key={faq.id} className="mb-lg-3">
                          <h3 className="questionTitle mb-3 h8">{faq.question}</h3>

                          <div className="mb-2 h8">{faq.answer}</div>
                        </div>
                      ))}
                      </div>
                    </React.Fragment>
                  ))}
              </div>
          </React.Fragment>
        ))}
      </div>
      <div className="tab-content d-none d-lg-block">
        {tabsData
          .filter((tab) => tab.id === activeTab)
          .map((tab) => (
            <React.Fragment key={`desktop-panel-${tab.id}`}>
              <h2 className="h7 font-600 mb-0">{tab.label}</h2>
              <div
                id={`tab-${tab.id}`}
                key={tab.id}
                role="tabpanel"
                aria-labelledby={`tab-${tab.id}`}
                className="mb-4"
              >
                {tab.faqs.map((faq) => (
                  <div key={faq.id} className="mb-lg-5">
                    <h3 className="questionTitle mb-3 h8">{faq.question}</h3>

                    <div className="mb-2 h8">{faq.answer}</div>

                  </div>
                ))}
              </div>
            </React.Fragment>
          ))}
      </div>
    </main>
  );
};

export default VerticalTabs;
